import _JSON$stringify from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/core-js/json/stringify";
import { isObject, isNull, toString, isUndefined } from "lodash";
export var erroToMsg = function erroToMsg(error) {
  try {
    if (isObject(error)) {
      //如果是错误类型:
      if (error.hasOwnProperty("message")) {
        return error.message;
      } else {
        return _JSON$stringify(error);
      }
    } else if (isNull(error)) {
      return _JSON$stringify(error);
    } else if (isUndefined(error)) {
      return _JSON$stringify(error);
    } else {
      return toString(error);
    }
  } catch (error) {
    return "undefined error";
  }
};